const WD_SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
const WD_SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';

function loadWdSwiperAssets() {
  if (!document.querySelector(`link[href="${WD_SWIPER_CSS}"]`)) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = WD_SWIPER_CSS;
    document.head.appendChild(link);
  }

  if (window.Swiper) return Promise.resolve(window.Swiper);

  const existing = document.querySelector(`script[src="${WD_SWIPER_JS}"]`);
  if (existing) {
    return new Promise((resolve, reject) => {
      if (window.Swiper) return resolve(window.Swiper);
      existing.addEventListener('load', () => resolve(window.Swiper), { once: true });
      existing.addEventListener('error', reject, { once: true });
    });
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = WD_SWIPER_JS;
    script.async = true;
    script.onload = () => resolve(window.Swiper);
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

class WdProductCarousel extends HTMLElement {
  connectedCallback() {
    if (this._initPromise) return;
    this._initPromise = this.init();
  }

  disconnectedCallback() {
    this.destroySwiper();
    this._initPromise = null;
  }

  async init() {
    const container = this.querySelector('[data-wd-carousel-swiper]');
    if (!container || this.swiper) return;

    try {
      await loadWdSwiperAssets();
    } catch (error) {
      console.error('WD Product Carousel: failed to load Swiper', error);
      return;
    }

    if (!window.Swiper || this.swiper) return;

    const prevButton = this.querySelector('[data-wd-carousel-prev]');
    const nextButton = this.querySelector('[data-wd-carousel-next]');

    this.swiper = new window.Swiper(container, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      slidesOffsetAfter: 20,
      watchOverflow: true,
      speed: 400,
      grabCursor: true,
      threshold: 8,
      touchAngle: 45,
      followFinger: true,
      preventClicks: true,
      preventClicksPropagation: true,
      // Only block swipe on ATC — image/title links must still drag.
      noSwipingSelector: '.wd-product-carousel__quick-add-btn, .wd-product-carousel__add-btn',
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton,
      },
      breakpoints: {
        768: {
          spaceBetween: 24,
          slidesOffsetAfter: 0,
        },
      },
    });
  }

  destroySwiper() {
    if (!this.swiper) return;
    this.swiper.destroy(true, true);
    this.swiper = null;
  }
}

if (!customElements.get('wd-product-carousel')) {
  customElements.define('wd-product-carousel', WdProductCarousel);
}
